import { render } from "./startmenu.vue?vue&type=template&id=61f38ec8&scoped=true"
import script from "./startmenu.vue?vue&type=script&lang=js"
export * from "./startmenu.vue?vue&type=script&lang=js"

import "../styles/homescreen.css?vue&type=style&index=0&id=61f38ec8&scoped=true&lang=css"
import "../styles/startmenu.css?vue&type=style&index=1&id=61f38ec8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\eoladipo\\Documents\\Windows 10 Mock\\Windows10-mock\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f38ec8"]])

export default __exports__